<template>
  <v-btn v-bind="$attrs" :prepend-icon="prependIcon" class="celus-button">
    <template v-for="(_, name) in $slots" #[name]>
      <slot :name="name" />
    </template>
  </v-btn>
</template>

<script setup lang="ts">
defineOptions({
  name: "CelusButton",
  inheritAttrs: false,
});

defineProps({
  prependIcon: {
    type: String,
    default: undefined,
  },
});
</script>

<style scoped>
/* Corner radius is per theme via the `button-border-radius` theme variable
   (plugins/vuetify.js); icon buttons keep Vuetify's circle. */
.celus-button:not(.v-btn--icon) {
  border-radius: var(--v-button-border-radius, 2px);
}
</style>
